
<image-container-card
  :as="as"
  :image="card.imageCustom || card.image"
  v-bind="$attrs"
  v-on="$listeners"
>
  <div class="showcase-card-info">
    <div class="card-set">{{ card.year }} {{ card.set }}</div>

    <div class="card-name">
      {{ card.player }}<span v-if="card.number"> #{{ card.number }}</span>
    </div>

    <div v-if="card.variation" class="card-detail">
      {{ card.variation }}
    </div>

    <div v-if="gradeLabel" class="card-detail card-grade">
      {{ gradeLabel }}
    </div>

    <div v-if="$slots.default" class="owner">
      <slot />
    </div>
  </div>
</image-container-card>
